import { DASHBOARD_URL } from "../../constant";
import { resourceRequest } from "../calls";

export function doFetchDashboard(token, data){
    return resourceRequest(token, DASHBOARD_URL, data);
}